export default __webpack_public_path__ + "locales/hy-AM/Errors.json?hash=36452bce9c0042bb555cd04fa2e7fc94";